module.exports = __webpack_public_path__ + "img/6_thumb.d310fcb8.jpg";